export const dayWordConstructor = (amount: number): string => {
  if (amount % 10 === 1 && amount % 100 !== 11) {
    return 'LOCAL.MODAL.DATE.DAY3'; // "день"
  } else if (amount % 10 >= 2 && amount % 10 <= 4 && (amount % 100 < 12 || amount % 100 > 14)) {
    return 'LOCAL.MODAL.DATE.DAY2'; // "дня"
  }
  return 'LOCAL.MODAL.DATE.DAY1'; // "дней"
};
